import Phaser from 'phaser'

type HudConfig = {
  objective: string
  hint: string
}

export class Hud {
  private readonly scene: Phaser.Scene

  private root: Phaser.GameObjects.Container

  private objectiveLabel: Phaser.GameObjects.Text

  private hintLabel: Phaser.GameObjects.Text

  private pauseButton: Phaser.GameObjects.Text

  private currentConfig: HudConfig

  private topHeight = 0

  private bottomHeight = 0

  constructor(scene: Phaser.Scene, config: HudConfig) {
    this.scene = scene
    this.currentConfig = config

    this.root = scene.add.container(0, 0)
    this.root.setDepth(Number.MAX_SAFE_INTEGER)

    this.objectiveLabel = scene.add.text(0, 0, config.objective, {
      fontFamily: 'Segoe UI, system-ui, sans-serif',
      color: '#f9fafb',
      align: 'left',
    })
    this.objectiveLabel.setVisible(false)

    this.pauseButton = scene.add
      .text(0, 0, 'Menú', {
        fontFamily: 'Segoe UI, system-ui, sans-serif',
        color: '#f7b538',
      })
      .setInteractive({ useHandCursor: true })

    this.hintLabel = scene.add.text(0, 0, config.hint, {
      fontFamily: 'Segoe UI, system-ui, sans-serif',
      color: '#e5e7eb',
      align: 'center',
    })
    this.hintLabel.setVisible(false)

    this.pauseButton.on('pointerdown', () => {
      this.scene.events.emit('hud-menu')
    })
    this.root.add([this.pauseButton])

    this.resize(this.scene.scale.width, this.scene.scale.height)
  }

  setObjective(text: string): void {
    this.currentConfig.objective = text
    this.objectiveLabel.setText(text)
  }

  setHint(text: string): void {
    this.currentConfig.hint = text
    this.hintLabel.setText(text)
  }

  resize(width: number, height: number): void {
    const safePadding = Math.max(12, Math.round(Math.min(width, height) * 0.015))
    const pauseFontSize = Math.max(22, Math.round(height * 0.05))

    const topMargin = safePadding

    this.pauseButton.setFontSize(pauseFontSize)
    this.pauseButton.setPosition(width - safePadding, topMargin + pauseFontSize / 2)
    this.pauseButton.setOrigin(1, 0.5)

    this.topHeight = topMargin + pauseFontSize + safePadding * 0.5
    this.bottomHeight = safePadding
  }

  destroy(): void {
    this.root.destroy(true)
  }

  getTopHeight(): number {
    return this.topHeight
  }

  getBottomHeight(): number {
    return this.bottomHeight
  }
}
